import { Component, forwardRef, HostListener, Inject, OnInit } from '@angular/core';
import { ConcessionarioPessoaTipoVinculo } from '@tivic-team/manager-ts/dist/mob/enums/concessionario-pessoa/concessionario-pessoa-tipo-vinculo';
import { MODAL_DATA, ModalService } from 'app/tools/modal/modal.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'modal-desativar',
  templateUrl: './modal-desativar.component.html',
  styleUrls: ['./modal-desativar.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class ModalDesativarComponent implements OnInit {
  
  titulo: string;

  @HostListener('document:keydown.escape', ['$event']) onEscClick(event: KeyboardEvent){
    event.preventDefault();
    this.close();
  }
  constructor(
    @Inject(forwardRef(() => MODAL_DATA)) public params,
    private _modalService: ModalService<ModalDesativarComponent>
  ) { }

  ngOnInit() { 
    this.nmTitulo;
  }

  get nmTitulo() {
    if(this.params.tpVinculo == ConcessionarioPessoaTipoVinculo.AUXILIAR) 
      return this.titulo = 'Inativar Motorista Auxiliar'

    return this.titulo = 'Inativar Representante'   
  }

  close(){
    this._modalService.dismiss();
  }
}
